<template>
  <textarea
    class="bb-dynamic-input bb-dynamic-input bb-input bb-input_border"
    :value="value"
    :ref="`refs-input-text-input_${id}`"
    @input="changeInput($event)"
  />
</template>

<script>
export default {
  name: 'DynamicInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    changeInput ({ target }) {
      this.$emit('update:value', target.value)
      this.setTextAreaHeight(target)
    },
    setTextAreaHeight (target) {
      const { scrollHeight = 0 } = target
      target.style.height = `${scrollHeight + 2}px`
    },
    setDefaultHeight () {
      const element = this.$refs[`refs-input-text-input_${this.id}`]
      if (!element) return
      const { scrollHeight } = element
      element.style.height = `${scrollHeight + 2}px`
    }
  },
  mounted () {
    this.setDefaultHeight()
  }
}
</script>

<style lang="scss" scoped>

  .bb-dynamic-input {
    resize: none;
    width: 100%;
    font-size: 12px;
    height: 32px;
    padding: 7px 10px 7px 15px;

    &::-webkit-scrollbar {
      width: 0;
    }

    &::-webkit-scrollbar {
      width: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/DynamicInput/DynamicInput.vue